import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './WhyHostNew.css';
import { graphql, gql, compose } from 'react-apollo';

// Components
import WhyHostBanner from './WhyHostBanner';
import WhyBlock from '../../components/WhyHost/WhyBlock';
import HostingBlock from '../../components/WhyHost/HostingBlock/HostingBlock';
import CoverSection from '../../components/WhyHost/CoverSection/CoverSection';
import ImageBanner from '../../components/WhyHost/ImageBanner/ImageBanner';
import PaymentContent from '../../components/WhyHost/PaymentContent/PaymentContent';
import QuoteSection from '../../components/WhyHost/QuoteSection/QuoteSection';
import CountingSection from '../../components/WhyHost/CountingSection/CountingSection';
import AboutSection from '../../components/WhyHost/AboutSection/AboutSection';
import FaqSection from '../../components/WhyHost/FaqSection/FaqSection';
import MoreSection from '../../components/WhyHost/MoreSection/MoreSection';
import OverlayImageBanner from '../../components/WhyHost/OverlayImageBanner/OverlayImageBanner';
import VideoSection from '../../components/WhyHost/VideoSection/VideoSection';
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import Loader from '../../components/Loader'
import getWhyHostReview from './getWhyHostReview.graphql';


// ES6 Imports
import Scroll from 'react-scroll'; // Imports all Mixins
import { scroller } from 'react-scroll'; //Imports scroller mixin, can use as scroller.scrollTo()


let Link = Scroll.Link;
let Element = Scroll.Element;
let Events = Scroll.Events;
let scroll = Scroll.animateScroll;
let scrollSpy = Scroll.scrollSpy;

const spanishDefaults = {
  quoteSectionTitle1: 'Viajar también es conectar',
  quoteSectionContent1: 'Descubrimos una finca cafetera, aprendimos de sus cultivos y nos llevamos una historia para recordar.',
  quoteSectionButton1: 'Ver experiencias',
  quoteSectionTitle2: 'Experiencias que dejan huella',
  quoteSectionContent2: 'Anfitriones locales nos guiaron con cercanía y nos ayudaron a conocer el territorio de una forma diferente.',
  quoteSectionButton2: 'Explorar destinos',
  faqTitle1: '¿Cómo puedo publicar un alojamiento?',
  faqContent1: 'Crea tu cuenta, elige Registrar alojamiento y completa la información, fotografías, precios y disponibilidad. Puedes guardar el avance y continuar después.',
  faqTitle2: '¿Cómo puedo publicar una experiencia?',
  faqContent2: 'Desde Convertirse en anfitrión selecciona Registrar experiencia y completa las diez pantallas del registro. Allí podrás indicar actividades, horarios, requisitos, precios y medidas de seguridad.',
  faqTitle3: '¿Puedo administrar mis reservas?',
  faqContent3: 'Sí. Desde tu panel puedes consultar reservas, mensajes, disponibilidad y la información de tus publicaciones.',
  faqTitle4: '¿Qué información debo entregar?',
  faqContent4: 'Solicitamos datos de contacto, ubicación, fotografías, condiciones del servicio y la información necesaria para que los viajeros tomen una decisión clara.',
  faqTitle5: '¿Cómo se realizan los pagos?',
  faqContent5: 'El precio y los cargos aplicables se muestran antes de confirmar. Las instrucciones de pago y los comprobantes se gestionan desde la plataforma.',
  faqTitle6: '¿Qué pasa si necesito cancelar?',
  faqContent6: 'Cada publicación tiene una política de cancelación visible antes de reservar. Revisa sus condiciones y comunícate con el anfitrión si necesitas ayuda.',
  faqTitle7: '¿Cómo protege Experiencia Rural a la comunidad?',
  faqContent7: 'Revisamos reportes, promovemos información veraz y pedimos a anfitriones y viajeros respetar las reglas, la seguridad y el entorno.',
  faqTitle8: '¿Dónde puedo pedir ayuda?',
  faqContent8: 'Visita Contáctanos y envía tu consulta. Incluye el correo de tu cuenta y el número de reserva o publicación cuando corresponda.'
};

const isPlaceholder = value => !value || /lorem|in publishing|what is lorem|dolor sit amet|exercitation|cupidatat|occaecat|fugiat est/i.test(value);

class EditProfile extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    const { data: { loading, getWhyHostPage } } = this.props;
    const { getWhyHostReview: { getHomeWhyHostReview, loading: reviewLoading } } = this.props;
    let settingsCollection = {}

    if (loading && reviewLoading) {

      return <Loader type={"text"} loaderClass={'textLoader'} />;

    } else {

      getWhyHostPage && getWhyHostPage.map((item, key) => {
        settingsCollection[item.name] = item.value
      });

      Object.keys(spanishDefaults).forEach(key => {
        if (isPlaceholder(settingsCollection[key])) settingsCollection[key] = spanishDefaults[key];
      });

      const spanishReviews = (getHomeWhyHostReview && getHomeWhyHostReview.results || []).map((review, index) => ({
        ...review,
        reviewContent: isPlaceholder(review.reviewContent)
          ? ['La experiencia fue cercana, clara y muy especial. Volveríamos sin dudarlo.', 'Un destino hermoso y un anfitrión atento. Todo estuvo bien explicado.', 'Aprendimos, descansamos y conocimos una nueva historia del territorio.'][index % 3]
          : review.reviewContent,
        userName: isPlaceholder(review.userName) ? ['María', 'Andrés', 'Camila'][index % 3] : review.userName
      }));

      return (
        <div className="whyhost-content">
          <WhyHostBanner data={settingsCollection} />
          <Element name="test1" className="element">
            <HostingBlock data={settingsCollection} />
            <CoverSection data={settingsCollection} />
            <ImageBanner data={settingsCollection} />
            {!reviewLoading && spanishReviews.length > 0 && <PaymentContent data={settingsCollection} reviewData={spanishReviews} />}
            <QuoteSection data={settingsCollection} />
            <FaqSection data={settingsCollection} />
          </Element>
        </div>
      );
    }
  }

}


export default compose(
  withStyles(s),
  graphql(getWhyHostPageSettings, {
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
  graphql(getWhyHostReview, {
    name: "getWhyHostReview",
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  })
)(EditProfile);
